"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const converterUtils_1 = require("../converterUtils");
const types_1 = require("./types");
const taskToOperationNode = (task) => {
    const { srcArtifactSlug: _unused2, ...nodeConfiguration } = task;
    return (0, converterUtils_1.newOperationNode)(types_1.nodeType, nodeConfiguration);
};
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const { configuration } = operationNode;
    (0, common_1.finleyAssert)(srcNodes.length === 1, `edit node has [${srcNodes.length}] src node`);
    return {
        srcArtifactSlug: (0, converterUtils_1.getSrcArtifactSlug)(srcNodes[0]),
        ...configuration,
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
const getDataDictionaryEntry = (task, { artifactSlug }) => {
    switch (task.mode) {
        case 'convertRange':
            return {
                kind: 'xlsxRange',
                artifactSlug,
                sheetName: task.sheetName,
                isSheetNameRegex: task.isSheetNameRegex ?? false,
                headerRange: task.headerRange,
                columns: task.fields.map(tape_sanitizer_1.toColumnInfo),
            };
        case 'extractValues':
            return {
                kind: 'xlsxValues',
                artifactSlug,
                columns: task.fields.map((field) => {
                    // tape-sanitizer rejects a field with neither (or both) of these.
                    const cellRange = field.cellRange ?? field.cell;
                    (0, common_1.finleyAssert)(cellRange, `[field:${field.field}] must specify cell or cellRange`);
                    return {
                        ...(0, tape_sanitizer_1.toColumnInfo)(field),
                        // a value is read from its cell, not looked up by header.
                        name: field.field,
                        sheetName: field.sheetName,
                        isSheetNameRegex: field.isSheetNameRegex ?? false,
                        cellRange,
                    };
                }),
            };
        default:
            return (0, common_1.finleyAssertUnreachable)(task);
    }
};
exports.convertor = {
    operation: 'xlsx2csv2',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
    toTransformation: (task) => {
        const { srcArtifactSlug: _unused, ...restOfParams } = task;
        return {
            isValid: true,
            data: {
                srcDataTape: null,
                ...restOfParams,
            },
        };
    },
    getDataDictionaryEntry,
};
//# sourceMappingURL=converter.js.map